module.exports = __webpack_public_path__ + "img/forecast_summary.9046dda3.png";